import React from 'react'

const Step2 = () => {
  return (
    <>
      <div className='step2'>
        <div className="flex-row s2-flx">
          <div className='s2-lt'>
            <h2>Content Creation & Campaign</h2>
            <p>
              Creation of Marketing Campaign including: Development of content calendar for web3 socials, Special storyline for NFT collection, Community building, Copywriting, Partnerships and Performance Analysis
            </p>
            <p>
              Design+Management of project website
            </p>
          </div>
          <div className='s2-rt'>
            <img src="images/steps/Group2.png" alt="" />
          </div>
        </div>
        <div className='bottom-line'>
          <p>Graphic Design (Figma, Photoshop, Canva) | Web Design (Figma, Webflow) | HTML, CSS | Social Media Management (Notion) | Video Processing (iMOVIE) | Email Marketing (Klaviyo) | AI Marketing (Acceleration of workflow through the use of AI tools
            | Storytelling | Copywriting | Outsourcing</p>
        </div>
      </div>
      <div className='s2-d'>
        <div><img src="images/steps/step2-3.jpg" alt="" /></div>
        <div><img src="images/steps/step2-2.jpg" alt="" /></div>
        <div><img src="images/steps/step2-1.png" alt="" /></div>
      </div></>
  )
}

export default Step2